import { Grid2, Stack } from '@mui/material'
import React from 'react'
import MaterialTypography from '../../../components/MaterialTypography'
import MaterialInput from '../../../components/MaterialInput'
import MaterialSelect from '../../../components/MaterialSelect'

const PersonalDetails = ({ basicDetails, handleBasicChange, handlePersonFieldChange }) => {
    return (
        <Grid2 container spacing={3} sx={{ padding: '10px' }}>
            {basicDetails.persons.map((person, index) => (
                <React.Fragment key={index}>
                    <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                        <Stack direction="column" spacing={1}>
                            <MaterialTypography variant="caption" color="text">
                                Person {index + 1} DOB<span style={{ color: 'red' }}>*</span>
                            </MaterialTypography>
                            <MaterialInput
                                type="date"
                                fullWidth
                                label="DOB"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={person.dob}
                                onChange={(e) => handlePersonFieldChange(index, 'dob', e.target.value)}
                            />
                        </Stack>
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                        <Stack direction="column" spacing={1}>
                            <MaterialTypography variant="caption" color="text">
                                Person {index + 1} First Name<span style={{ color: 'red' }}>*</span>
                            </MaterialTypography>
                            <MaterialInput
                                fullWidth
                                label="First Name"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={person.firstName}
                                onChange={(e) => handlePersonFieldChange(index, 'firstName', e.target.value)}
                            />
                        </Stack>
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                        <Stack direction="column" spacing={1}>
                            <MaterialTypography variant="caption" color="text">
                                Person {index + 1} Last Name<span style={{ color: 'red' }}>*</span>
                            </MaterialTypography>
                            <MaterialInput
                                fullWidth
                                label="Last Name"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                value={person.lastName}
                                onChange={(e) => handlePersonFieldChange(index, 'lastName', e.target.value)}
                            />
                        </Stack>
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                        <Stack direction="column" spacing={1}>
                            <MaterialTypography variant="caption" color="text">
                                Person {index + 1} Gender<span style={{ color: 'red' }}>*</span>
                            </MaterialTypography>
                            <MaterialSelect
                                label="Gender"
                                fullWidth
                                variant="outlined"
                                value={person.gender}
                                onChange={(e) => handlePersonFieldChange(index, 'gender', e.target.value)}
                                options={[
                                    { value: 'male', label: 'Male' },
                                    { value: 'female', label: 'Female' },
                                    { value: 'other', label: 'Other' },
                                ]}
                            />
                        </Stack>
                    </Grid2>

                    <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                        <Stack direction="column" spacing={1}>
                            <MaterialTypography variant="caption" color="text">
                                Person {index + 1} Relation<span style={{ color: 'red' }}>*</span>
                            </MaterialTypography>
                            <MaterialSelect
                                label="Relation"
                                fullWidth
                                variant="outlined"
                                value={person.relation}
                                onChange={(e) => handlePersonFieldChange(index, 'relation', e.target.value)}
                                options={[
                                    { value: 'self', label: 'Self' },
                                    { value: 'spouse', label: 'Spouse' },
                                    { value: 'child', label: 'Child' },
                                    { value: 'parent', label: 'Parent' },
                                ]}
                            />
                        </Stack>
                    </Grid2>
                </React.Fragment>
            ))}
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction="column" spacing={1}>
                    <MaterialTypography variant="caption" color="text">
                        Address 1<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                        label="Address 1"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={basicDetails.address1}
                    />
                </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction="column" spacing={1}>
                    <MaterialTypography variant="caption" color="text">
                        Address 2
                    </MaterialTypography>
                    <MaterialInput
                        label="Address 2"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={basicDetails.address2}
                    />
                </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction="column" spacing={1}>
                    <MaterialTypography variant="caption" color="text">
                        Email<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                        label="Email"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={basicDetails.email}
                    />
                </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
                <Stack direction="column" spacing={1}>
                    <MaterialTypography variant="caption" color="text">
                        Phone number<span style={{ color: 'red' }}>*</span>
                    </MaterialTypography>
                    <MaterialInput
                        label="Phone number"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        value={basicDetails.phoneNumber}
                    />
                </Stack>
            </Grid2>
        </Grid2>

    )
}

export default PersonalDetails
